"use client";

import { IMenu } from "@/types/strapi-menu";
import Link from "next/link";

/**
 * Pour copier le SIRET sans les espaces au clic sur ce dernier
 * @param e
 */
const copySIRET = async () => {
	try {
		await navigator.clipboard.writeText("83275167100047");
		console.log("✅ SIRET copié dans le presse-papier !");
	} catch (err) {
		console.error("❌ Erreur lors de la copie :", err);
	}
};

function CopyrightFooter({ menu }: { menu?: IMenu }) {
	return (
		<aside className="border-t-1 container mt-10 pt-6 sm:flex justify-between text-gray-500 ">
			<p onClick={copySIRET}>
				2014 - {new Date().getFullYear()} © Audrey Hossepian
			</p>
			{menu ? (
				<nav>
					<ul className="md:flex gap-4 flex-wrap">
						{menu.item.map((a) => (
							<li key={a.id}>
								<Link className="hover:underline" href={a.slug}>
									{a.label}
								</Link>
							</li>
						))}
					</ul>
				</nav>
			) : null}
		</aside>
	);
}
export default CopyrightFooter;
